import { connect } from 'react-redux';
import { getAssignmentInfo, resetPopover, getHomeToVisitPostcodeDistance } from '../../../actions/areas/dailyPlanning';
import TimelineAssignmentPopover from '../../../components/DailyPlanning/TimelineAssignment/TimelineAssignmentPopover';
import { dismissError } from '../../../actions/areas/dailyPlanning/homeToVisitUserMessages';

const mapStateToProps = ({ areas: { dailyPlanning } }) => ({
  description: dailyPlanning.assignmentInfo.description,
  timeSlots: dailyPlanning.assignmentInfo.timeSlots,
  distance: dailyPlanning.assignmentDistanceInfo.distance,
  isFetchingDistance: dailyPlanning.assignmentDistanceInfo.isFetching,
  failureMessage: dailyPlanning.assignmentDistanceMessages.failure,
});

const mapDispatchToProps = dispatch => ({
  getAssignmentInfo: id => dispatch(getAssignmentInfo(id)),
  resetPopover: () => dispatch(resetPopover()),
  dismissError: () => dispatch(dismissError()),
  getHomeToVisitPostcodeDistance: (treeatmentId, assignmentId) =>
    dispatch(getHomeToVisitPostcodeDistance(treeatmentId, assignmentId)),
});

const TimelineAssignmentPopoverContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(TimelineAssignmentPopover);

export default TimelineAssignmentPopoverContainer;
